import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('BuyMoreKeys').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: 'black',
    position: 'relative',
    zIndex: '5',
    gap: '4px',
    overflow: 'hidden',
    height: '100px',
    width: '100%',
    minHeight: '100px',
    borderRadius: '12px',
  },
  background: {
    position: 'absolute',
    width: '110%',
    bottom: '-0%',
    left: '15%',
    zIndex: '0',

    mask: 'linear-gradient( 105deg, rgba(255, 255, 255, 0.1) 15%, rgba(255, 255, 255, 1) 45%, rgba(255, 255, 255, 1) 90%, rgba(255, 255, 255, 0) 90% )',
  },
  button: {
    height: '36px',
    margin: '8px 16px',
    borderRadius: '24px',
    width: '35%',
  },

  divWrapper: {
    display: 'flex',
    position: 'relative',
    padding: '12px 16px',
    paddingBottom: '0px',
    zIndex: 1,
    width: '100%',
    flexDirection: 'column',
  },
  boredText: {
    fontFamily: 'Inter',
    fontWeight: 450,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.l,
    color: theme.colors.text.primary,
    whiteSpace: 'nowrap',
  },

  buttonText: {
    fontFamily: 'Inter',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontWeight: 560,
    padding: '8px 16px',
    whiteSpace: 'nowrap',
    color: 'rgba(85, 72, 12, 1)',
  },

  goldenText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: theme.sizes.texts.lineHeight.l,

    letterSpacing: '-0.01em',
    color: theme.colors.text.golden,
  },

  modalTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
  },

  keyList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '12px',
    overflow: 'auto',
    color: theme.colors.text.primary,
  },

  keyListHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: '#757778',
    padding: '12px 0px',
    textTransform: 'uppercase',
  },

  keyListItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
    padding: '12px 0px',
  },
  keyListItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '6px',
    color: theme.colors.text.primary,
  },
  keyListItemKey: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '18px',
    aspectRatio: '1/1',

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  stars: {
    color: theme.colors.text.secondary,
  },
}))
